import { useQuery } from '@tanstack/react-query';
import { useKeycloak } from '@react-keycloak/web';

interface UserVaultsData {
  label: string;
  value: string;
  dataClassUuid: string;
}

export function useGetUserVault() {
  const { keycloak } = useKeycloak();

  return useQuery({
    enabled: !!keycloak.token,
    queryKey: ['userVaultOptions'],
    queryFn: async (): Promise<UserVaultsData[]> => {
      const response = await fetch(
        `${
          import.meta.env.VITE_USER_ENGINE_ENDPOINT
        }/api/v1/bundles/user_bundle/functions/get_vault_item_options`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${keycloak.token}`,
          },
          method: 'GET',
        }
      );

      const data = await response.json();

      return data?.data || [];
    },
  });
}
